module.exports = __webpack_public_path__ + "static/media/br.28bc019e.svg";